"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = exports.technoCardsSizes = void 0;
var styles_1 = require("@material-ui/core/styles");
var styles_2 = require("../../styles");
exports.technoCardsSizes = {
    mobile: {
        width: 60 + 1 * 8,
        height: 80 + 1 * 8,
    },
    other: {
        width: 80 + 1.5 * 8,
        height: 120 + 1.5 * 8,
    },
};
var styles = function (_a) {
    var spacing = _a.spacing;
    return styles_1.createStyles({
        container: {
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
        },
        textField: {
            minHeight: 60,
            minWidth: 400,
            marginBottom: spacing(3),
            '@media screen and (max-width: 500px)': {
                minWidth: 'unset',
            },
        },
        technologiesListWrapper: {
            width: '100%',
            overflow: 'auto',
        },
        technologiesList: {
            paddingRight: 0,
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            '@media screen and (max-width: 500px)': {
                justifyContent: 'center',
                marginLeft: 'unset',
            },
        },
        technologyItem: function (_a) {
            var isMobile = _a.isMobile;
            return ({
                width: isMobile ? 60 : 80,
                maxWidth: isMobile ? 60 : 80,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                margin: isMobile ? spacing(1) : spacing(1.5),
            });
        },
        technologyImageContainer: function (_a) {
            var isMobile = _a.isMobile;
            return ({
                width: isMobile ? 60 : 80,
                maxWidth: isMobile ? 60 : 80,
                height: isMobile ? 60 : 80,
                maxHeight: isMobile ? 60 : 80,
                position: 'relative',
                padding: spacing(1.5),
                marginBottom: spacing(2),
                overflow: 'hidden',
            });
        },
        technologyImage: {
            width: '100%',
            height: '100%',
            objectFit: 'contain',
        },
        typography: {
            textAlign: 'center',
            linebreak: 'anywhere',
        },
        selectedTechnologyLayer: {
            zIndex: 2,
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: styles_2.primary[500],
            color: 'white',
            textAlign: 'center',
            borderRadius: 5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        checkboxButton: {
            display: 'flex',
            alignItems: 'center',
            textAlign: 'left',
        },
        checkbox: {
            minWidth: 24,
        },
    });
};
exports.styles = styles;
